import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import Root from './components/Root';
import { store, history } from './store';
import * as Sentry from '@sentry/react';
import constants from '@/constants';

if(!__DEV__){ //eslint-disable-line
    Sentry.init({ dsn: constants.sentryDsn, environment: constants.envName, release: process.env.sentryReleaseVersion});
}

render(
    <AppContainer>
        <Root store={store} history={history} />
    </AppContainer>,
    document.getElementById('app')
);

if (module.hot) {
    module.hot.accept('./components/Root', () => {
        const NewRoot = require('./components/Root').default;
        render(
            <AppContainer>
                <NewRoot store={store} history={history} />
            </AppContainer>,
            document.getElementById('app')
        );
    });
}
